import React from 'react';
import './loader.scss';

const Loader: React.FC = () => {
  return (
    <div className="spinner-loader">
      <div className="spinner colorful"></div>
    </div>
  );
};

export default Loader;
